import type { ReactNode } from "react";
import { useSession } from "../lib/use-session";
import { LoginPage } from "../pages/login-page";

// Renders the app only for an authenticated navio-platform session; else the login surface.
export function AuthGate({ children }: { children: ReactNode }) {
  const { session, loading } = useSession();

  if (import.meta.env.VITE_E2E_AUTH_BYPASS === "true") return <>{children}</>;

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background text-foreground/70">
        Loading…
      </div>
    );
  }

  return session ? <>{children}</> : <LoginPage />;
}
